import styled from 'styled-components';

export const DayContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const TimelineHeader = styled.div`
    height: 20%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    user-select: none;
`;

export const HourCaption = styled.div`
    color: ${({ theme: { colors } }) => (colors.grayColors.mediumGray)};
    font-weight: bold;
    display: flex;
    flex-direction: row;
    font-size: 12px;
    justify-content: center;
`;

export const ScaleMark = styled.div`
     color: ${({ theme: { colors } }) => (colors.grayColors.darkGray)};
    display: flex;
    flex-direction: row;
    font-size: 8px;
    justify-content: center;
    @media only screen and (min-width: 1700px) {
    margin-left: 3px;
    }
`;

export const ObligationsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 70%;
    margin-top: 2px;
    width: 100%;
    align-self: center;
    user-select: none;
    overflow: hidden;
    @media only screen and (max-width: 1700px) {
    width: 98%;
    margin-top: 5px;
    }
`;

export const ObligationsContainer = styled.div`
    background-color: ${({ theme: { colors } }) => (colors.grayColors.lightGray)};
    color: ${({ theme: { colors } }) => (colors.mainColors.white)};
    height: 70%;
    width: 100%;
    border-radius: 9px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    height: 80%;
    overflow: hidden;
    position: relative;
`;

export const ObligationCard = styled.div`
    width: ${(props) => (props?.duration * props?.hourCellWidth)}px;
    position: absolute;
    background-color: ${(props) => {
        switch (props?.sectorName) {
            case 'L':
            case 'LU':
                return '#78D59A'; // GREEN
            case 'U':
                return '#FFC067'; // ORANGE
            case 'H':
            case 'HT':
            case 'UHT':
            case 'LUHT':
            case 'LUHTS':
            case 'HTS':
            case 'UHTS':
                return '#FF9E99'; // RED
            case 'T':
            case 'TS':
                return '#8FD9FB'; // BLUE
            case 'S':
                return '#FFEE8C'; // YELLOW
            case 'FMP':
            case 'ŠS':
            case 'ŠS/FMP':
            case 'SATCO':
                return '#cdb1ca';
            case 'SB':
                return 'gray';
            default:
                return 'gray';
        }
    }};
    border-radius: 9px;
    font-weight: bold;
    font-size: 25px;
    height: 100%;
    box-sizing: border-box;
    color: white;
    left: ${(props) => (props?.timeFrom - props?.intervalFrom) * props?.hourCellWidth}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid #dfdfdf;
    overflow: hidden;
`;

export const RoleTypeBox = styled.div`
  text-align: center;
  color: #707070;
  background-color: ${(props) => (props?.roleTypeName === 'EXE' ? '#b51200' : '#539441')};
  height: 6px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const Title = styled.div`
    font-size: ${(props) => {
      if (props?.duration < 1) {
        if (props?.charCount > 6) return '8px';
        if (props?.charCount === 5) return '11px';
        return '15px';
      }
      return '20px';
    }};
    line-height: 20px;
    margin: 0 auto;
    text-orientation: ${(props) => (props?.duration < 1 ? 'upright' : 'initial')};
    writing-mode: ${(props) => (props?.duration < 1 ? 'vertical-rl' : 'initial')};
    letter-spacing: ${(props) => (props?.duration < 1 ? '-4px' : 'initial')};
    color: black;
`;

export const RoleTypeLabel = styled.div`
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
`;
